import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-arrow-narrow-left",
  templateUrl: "./arrow-narrow-left.component.html",
  styleUrls: ["./arrow-narrow-left.component.scss"],
})
export class ArrowNarrowLeftComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
